// src/pages/gt3x/Briefing.jsx
import { useEffect, useMemo, useState } from "react";
import { fetchSheetViaProxy } from "../../lib/sheets";
import RaceSessionSelect from "../../components/RaceSessionSelect";

const RANGE = "Briefings!A1:AI100";

// kleine Hilfsfunktion: Text/Zelle rendern, URLs als Link/Bild
// kleine Hilfsfunktion: Text/Zelle rendern, URLs als Link
function renderCell(cell) {
    if (cell == null) return "";
    const str = String(cell).trim();
    if (!str) return "";

    // URL?
    if (/^https?:\/\//i.test(str)) {
        // Bild-URL? (png/jpg/jpeg/gif/webp/svg)
        if (/\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(str)) {
            return (
                <a href={str} target="_blank" rel="noreferrer">
                    <img
                        src={str}
                        alt=""
                        style={{ maxWidth: "100%", height: "auto", display: "block" }}
                    />
                </a>
            );
        }

        // normale URL → Textlink
        return (
            <a href={str} target="_blank" rel="noreferrer">
                {str}
            </a>
        );
    }

    return str;
}


// Block-Helfer: Zeilenbereich aus Matrix holen (2 Spalten)
function sliceBlock(matrix, colStart, firstRow, lastRow) {
    const col2 = colStart + 1;
    const out = [];

    for (let r = firstRow; r <= lastRow; r++) {
        const row = matrix[r];
        if (!row) continue;

        const left = row[colStart] ?? "";
        const right = row[col2] ?? "";

        if (
            (left && String(left).trim() !== "") ||
            (right && String(right).trim() !== "")
        ) {
            out.push([left, right]);
        }
    }
    return out;
}

function BriefingTables({ data }) {
    const everett = { fontFamily: "var(--ff-Everett), sans-serif" };

    if (!data) {
        return (
            <div className="card overview-card">
                <p className="muted">
                    Für dieses Rennen sind aktuell noch keine Briefing-Daten hinterlegt.
                </p>
            </div>
        );
    }

    const {
        sessionRows,
        trackRows,
        detailRows,
        weather: { img1Left, img1Right, tempImg, cloudsImg },
    } = data;

    // Debug-Ausgabe, damit wir sehen, ob rechte Spalte wirklich leer ist
    console.log("Briefing sessionRows:", sessionRows);
    console.log("Briefing trackRows:", trackRows);
    console.log("Briefing detailRows:", detailRows);

    return (
        <div className="card overview-card">
            {/* 1. Session – inGame Zeiten */}
            <section className="briefing-section" style={{ marginBottom: 24 }}>
                <div className="fancyTable">
                    <table className="tbl tbl-overview-table overview-table tbl-briefing">
                        <thead>
                        <tr>
                            <th className="align-left">Session</th>
                            <th className="align-left">inGame Zeiten</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        {sessionRows.map(([left, right], idx) => (
                            <tr key={idx}>
                                <td className="align-left">{renderCell(left)}</td>
                                <td className="align-left">{renderCell(right)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </section>

            {/* 2. Track State */}
            <section className="briefing-section" style={{ marginBottom: 24 }}>
                <div className="fancyTable">
                    <table className="tbl tbl-overview-table overview-table tbl-briefing">
                        <thead>
                        <tr>
                            <th className="align-left">Trackstate</th>
                            <th className="align-left">Details</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        {trackRows.map(([left, right], idx) => (
                            <tr key={idx}>
                                <td className="align-left">{renderCell(left)}</td>
                                <td className="align-left">{renderCell(right)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </section>

            {/* 3. Wetter (aus GT-Sprint Serie) */}
            <section className="briefing-section" style={{ marginBottom: 24 }}>
                <div className="fancyTable">
                    <table className="tbl tbl-overview-table overview-table tbl-briefing">
                        <thead>
                        <tr>
                            <th className="align-left">Wetter (aus GT-Sprint Serie)</th>
                            <th className="align-left">Details</th>
                        </tr>
                        </thead>
                        <tbody>
                        {/* Zeile 1: zwei Karten nebeneinander */}
                        <tr>
                            <td className="weather-img-cell weather-img-cell--narrow">
                                {img1Left && <img src={img1Left} alt="Weather map 1" />}
                            </td>
                            <td className="weather-img-cell">
                                {img1Right && <img src={img1Right} alt="Weather map 2" />}
                            </td>
                        </tr>

                        {/* Forecast Temperature */}
                        <tr>
                            <td colSpan={2} className="weather-subtitle">
                                Forecast Temperature
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="weather-img-row">
                                {tempImg && (
                                    <img src={tempImg} alt="Forecast temperature" />
                                )}
                            </td>
                        </tr>

                        {/* Clouds & Percipitation */}
                        <tr>
                            <td colSpan={2} className="weather-subtitle">
                                Forecast Clouds &amp; Percipitation
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2} className="weather-img-row">
                                {cloudsImg && (
                                    <img src={cloudsImg} alt="Clouds & precipitation" />
                                )}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            {/* 4. Weitere Details */}
            <section className="briefing-section">
                <div className="fancyTable">
                    <table className="tbl tbl-overview-table overview-table tbl-briefing">
                        <thead>
                        <tr>
                            <th className="align-left">Weitere Details</th>
                            <th className="align-left">Details</th>
                        </tr>
                        </thead>
                        <tbody style={everett}>
                        {detailRows.map(([left, right], idx) => (
                            <tr key={idx}>
                                <td className="align-left">{renderCell(left)}</td>
                                <td className="align-left">{renderCell(right)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    );
}

export default function Briefing() {
    const [race, setRace] = useState(1); // R1..R12
    const [trackLabel, setTrackLabel] = useState("");

    const [matrix, setMatrix] = useState([]); // komplette Matrix A1..AI als 2D-Array
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    // Daten aus Google Sheet holen
    useEffect(() => {
        (async () => {
            setLoading(true);
            setErr("");

            try {
                const res = await fetchSheetViaProxy({ range: RANGE });

                let m = [];

                // Fall 1: res.values (klassische Sheets-API)
                if (Array.isArray(res?.values) && res.values.length > 0) {
                    m = res.values;
                }
                // Fall 2: header + rows (wie bei Standings)
                else if (Array.isArray(res?.header) && Array.isArray(res?.rows)) {
                    const headers = res.header;
                    const headerRow = headers;
                    const bodyRows = (res.rows || []).map((rowObj) =>
                        headers.map((h) => rowObj[h] ?? "")
                    );
                    m = [headerRow, ...bodyRows];
                }

                console.log("Briefing raw matrix:", m);
                setMatrix(m);
            } catch (e) {
                console.error("Briefing load error:", e);
                setErr("Fehler beim Laden der Briefing-Daten.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    // Datenblöcke für das ausgewählte Rennen bauen
    const dataForRace = useMemo(() => {
        if (!Array.isArray(matrix) || matrix.length === 0) return null;

        // Zuordnung:
        // R1 -> A/B (0,1)
        // R2 -> D/E (3,4)
        // R3 -> G/H (6,7)
        // ... jeweils +3 Spalten weiter
        const colStart = (race - 1) * 3;

        // 1. Session – inGame Zeiten: Zeilen 3–6 => Index 2..5
        const sessionRows = sliceBlock(matrix, colStart, 2, 5);

        // 2. Track State: Zeilen 9–10 => Index 8..9
        const trackRows = sliceBlock(matrix, colStart, 8, 9);

        // 3. Wetter-URLs: rechte Spalte (B/E/…)
        const urlCol = colStart;
        // NEU: A12–A15 / D12–D15 / ...
        const img1Left  = matrix[11]?.[urlCol] ?? ""; // A12 / D12 ...
        const img1Right = matrix[12]?.[urlCol] ?? ""; // A13 / D13 ...
        const tempImg   = matrix[13]?.[urlCol] ?? ""; // A14 / D14 ...
        const cloudsImg = matrix[14]?.[urlCol] ?? ""; // A15 / D15 ...

        // NEU: Weitere Details liegen in A17:B28
        const detailRows = sliceBlock(matrix, colStart, 16, 27);

        const hasContent =
            sessionRows.length ||
            trackRows.length ||
            detailRows.length ||
            img1Left ||
            img1Right ||
            tempImg ||
            cloudsImg;

        if (!hasContent) return null;

        return {
            sessionRows,
            trackRows,
            detailRows,
            weather: { img1Left, img1Right, tempImg, cloudsImg },
        };
    }, [matrix, race]);

    return (
        <>
            {/* Rennen auswählen */}
            <RaceSessionSelect
                valueRace={race}
                onRaceChange={setRace}
                showSession={false}
                onTrackLabelChange={setTrackLabel}
            />

            {/* Top-Card */}
            <div className="card briefing-card-top">
                <h2>Briefing</h2>
                <p className="muted">
                    Briefing-Infos für {trackLabel || `R${race}`}.
                </p>
            </div>

            {err && (
                <div className="card overview-card">
                    <p className="muted">{err}</p>
                </div>
            )}

            {loading && (
                <div className="card overview-card">
                    <p>Lade Briefing-Daten …</p>
                </div>
            )}

            {!loading && !err && <BriefingTables data={dataForRace} />}
        </>
    );
}
